/**
 *
 * @param {String} launchURLString
 * @param {Object} urlParams //key-value pairs of url parameters to be appended to end of launchURLString
 * @returns String
 */
export const addURLParamsToLaunchURL = (launchURLString, urlParams) => {
  launchURLString = launchURLString.endsWith('/') ? launchURLString.slice(0, -1) : launchURLString
  const paramsString = Object.entries(urlParams).reduce((previousValue, paramKeyValuePair) => {
    if (previousValue.length > 0) {
      return `${previousValue}&${paramKeyValuePair}[0]=${paramKeyValuePair[1]}`
    }

    return `?${paramKeyValuePair[0]}=${paramKeyValuePair[1]}`
  }, '')

  return launchURLString + paramsString
}
export default addURLParamsToLaunchURL
